import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { knowledgeSetItemDetails } from 'src/store/actions/knowledgeViewer.actions';
import { KnowledgeInfoComponent } from './knowledge-info.component';
import {
  getItemCategory,
  getKnowledgeParentsByItemIdWithWorkspace,
} from 'shared/store/selectors/knowledge.selector';
import { getOwnerById } from 'shared/store/selectors/owners.selector';
import { useKnowledgeItem } from 'shared/hooks/knowledge-items.hooks';

export function KnowledgeInfo() {
  const dispatch = useDispatch();
  const { itemId, ownerId } = useSelector(state => state.knowledgeViewer);
  const lang = useSelector(state => state.lang.INFORMATION_MODAL);
  // Slices in, derived values out: these selectors build fresh objects per call.
  const knowledge = useSelector(state => state.knowledge);
  const workspace = useSelector(state => state.workspace);
  const owners = useSelector(state => state.owners);
  const { data: knowledgeItem } = useKnowledgeItem(itemId);
  const setItemDetails = React.useCallback(
    details => dispatch(knowledgeSetItemDetails(details)),
    [dispatch],
  );

  if (!itemId) {
    return <KnowledgeInfoComponent itemId={itemId} lang={lang} />;
  }

  // Binder paths and the parent's sync flag still come from the categories tree.
  const { paths } = getKnowledgeParentsByItemIdWithWorkspace(knowledge, workspace, { id: itemId });

  return (
    <KnowledgeInfoComponent
      itemId={itemId}
      {...(knowledgeItem || {})}
      ownerObject={ownerId ? getOwnerById(owners, { id: ownerId }) : null}
      ownerIds={knowledgeItem?.ownerIds}
      parents={paths}
      itemCategory={getItemCategory({ knowledge }, { id: itemId })}
      lang={lang}
      knowledgeSetItemDetails={setItemDetails}
    />
  );
}
